<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="svg-icon"
    viewBox="0 0 100 100"
  >
    <path
      d="M50,.563a50,50,0,1,0,50,50A49.991,49.991,0,0,0,50,.563ZM66.129,34.433a6.452,6.452,0,1,1-6.452,6.452A6.445,6.445,0,0,1,66.129,34.433Zm-32.258,0a6.452,6.452,0,1,1-6.452,6.452A6.445,6.445,0,0,1,33.871,34.433ZM73.145,68.748a30.117,30.117,0,0,1-46.29,0c-2.742-3.286,2.218-7.4,4.96-4.133a23.689,23.689,0,0,0,36.371,0C70.887,61.349,75.867,65.462,73.145,68.748Z"
      transform="translate(0 -0.563)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSmiley"
};
</script>
